import Vue from 'vue'
import Form from '@/components/form/Form.vue'
import HeaderForm from '@/components/form/Header.vue'
import Field from '@/components/form/Field.vue'
import Title from '@/components/form/field/Title.vue'
import SubTitle from '@/components/form/field/SubTitle.vue'
import InputText from '@/components/form/field/InputText.vue'
import Select from '@/components/form/field/Select.vue'
import AutoComplete from '@/components/form/field/AutoComplete.vue'
import Textarea from '@/components/form/field/Textarea.vue'
import Checkbox from '@/components/form/field/Checkbox.vue'
import Radio from '@/components/form/field/Radio.vue'
import SwitchToggle from '@/components/form/field/SwitchToggle.vue'
import Date from '@/components/form/field/Date.vue'
import Group from '@/components/form/field/Group.vue'
import Time from '@/components/form/field/Time.vue'

Vue.component('Form', Form)
Vue.component('HeaderForm', HeaderForm)
Vue.component('Title', Title)
Vue.component('SubTitle', SubTitle)
Vue.component('Field', Field)
Vue.component('InputText', InputText)
Vue.component('Select', Select)
Vue.component('AutoComplete', AutoComplete)
Vue.component('Textarea', Textarea)
Vue.component('Checkbox', Checkbox)
Vue.component('Radio', Radio)
Vue.component('SwitchToggle', SwitchToggle)
Vue.component('Date', Date)
Vue.component('Time', Time)
Vue.component('Group', Group)
